var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { createComponent } from '@cloudflare/style-container';
import { Icon } from '@cloudflare/component-icon';
import { sendEvent, ConnectEventTracking } from '@cloudflare/util-user-tracking';

var radius = function radius(props) {
  var spaced = props.spaced,
      group = props.group,
      theme = props.theme;

  var borderRadius = theme.borderRadius;
  if (spaced) {
    return { borderRadius: borderRadius };
  }
  if (group && !spaced) {
    return {
      borderTopRightRadius: group === 'last' ? borderRadius : 0,
      borderTopLeftRadius: group === 'first' ? borderRadius : 0,
      borderBottomLeftRadius: group === 'first' ? borderRadius : 0,
      borderBottomRightRadius: group === 'last' ? borderRadius : 0
    };
  }
  return { borderRadius: borderRadius };
};

var opacity = function opacity(props) {
  return {
    opacity: props.loading || props.disabled ? 0.5 : 'inherit'
  };
};

var before = function before(props) {
  return props.loading ? {
    '&::before': {
      content: '"…"',
      color: 'black',
      display: 'block',
      position: 'absolute',
      top: '0.6em',
      left: 0,
      height: '100%',
      width: '100%',
      opacity: 1,
      animationName: {
        '50%': { opacity: 0 }
      },
      animationDuration: '1s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear'
    }
  } : undefined;
};

var margin = function margin(props) {
  var theme = props.theme,
      group = props.group,
      spaced = props.spaced,
      direction = props.direction;

  var marginTop = !group || direction === 'row' ? theme.marginTop : spaced && direction === 'column' && group !== 'first' ? '0.4rem' : 0;
  var marginLeft = !group || direction === 'column' ? theme.marginLeft : spaced && group !== 'first' ? '0.4rem' : 0;

  return {
    marginTop: marginTop,
    marginRight: group ? 0 : theme.marginRight,
    marginBottom: group ? 0 : theme.marginBottom,
    marginLeft: marginLeft
  };
};

var border = function border(props) {
  var theme = props.theme,
      inverted = props.inverted,
      group = props.group;

  var borderColor = colorAccessor(theme.normal.borderColor, props);
  return {
    borderBottomWidth: 1,
    borderLeftWidth: inverted ? 1 : group && group !== 'first' ? 0 : 1,
    borderRightWidth: inverted ? 1 : 0,
    borderTopWidth: inverted ? 1 : 0,
    borderBottomStyle: 'solid',
    borderTopStyle: 'solid',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderLeftColor: borderColor,
    borderTopColor: borderColor,
    borderBottomColor: borderColor,
    borderRightColor: borderColor
  };
};

var colorAccessor = function colorAccessor(property, props) {
  var inverted = props.inverted,
      type = props.type;

  return !property ? undefined : inverted ? property.inverted[type] : property[type];
};

var interactionStyleAccessor = function interactionStyleAccessor(interactionState, props) {
  var theme = props.theme,
      loading = props.loading,
      disabled = props.disabled;

  var isInteractive = !(loading || disabled);
  var stateStyles = theme[interactionState];

  return isInteractive ? {
    backgroundColor: colorAccessor(stateStyles.backgroundColor, props),
    borderColor: colorAccessor(stateStyles.borderColor, props),
    color: colorAccessor(stateStyles.color, props)
  } : undefined;
};

var styles = function styles(props) {
  var theme = props.theme,
      iconType = props.iconType,
      children = props.children,
      loading = props.loading,
      disabled = props.disabled,
      direction = props.direction;

  var iconOnly = iconType && !children;
  var normalStyles = theme.normal;
  var backgroundColor = colorAccessor(normalStyles.backgroundColor, props);
  var color = colorAccessor(normalStyles.color, props);

  return _extends({
    '&:hover': interactionStyleAccessor('hover', props),
    '&:active': interactionStyleAccessor('active', props),
    '&:focus': interactionStyleAccessor('focus', props),
    '&:focus:hover': interactionStyleAccessor('focus', props),
    '&:active:hover': interactionStyleAccessor('active', props),

    '&[title]': {
      pointerEvents: disabled ? 'auto' : 'none'
    },

    backgroundColor: backgroundColor,
    color: loading ? backgroundColor : color,

    cursor: disabled || loading ? 'default' : theme.cursor,
    display: theme.display,

    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize,
    fontWeight: theme.fontWeight,
    lineHeight: theme.lineHeight

  }, before(props), border(props), margin(props), opacity(props), radius(props), {

    paddingBottom: iconOnly ? '5px' : theme.paddingBottom,
    paddingLeft: iconOnly ? '9px' : theme.paddingLeft,
    paddingRight: iconOnly ? '9px' : theme.paddingRight,
    paddingTop: iconOnly ? '9px' : theme.paddingTop,

    pointerEvents: disabled ? 'none' : 'auto',
    position: theme.position,

    textAlign: theme.textAlign,

    transitionProperty: theme.transitionProperty,
    transitionDuration: theme.transitionDuration,
    transitionTimingFunction: theme.transitionTimingFunction,

    userSelect: theme.userSelect,
    maxWidth: theme.maxWidth,
    float: theme.float,
    width: direction === 'column' ? '100%' : 'auto'
  });
};

var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          submit = _props.submit,
          className = _props.className,
          disabled = _props.disabled,
          loading = _props.loading,
          testId = _props.testId,
          children = _props.children,
          onClick = _props.onClick,
          iconType = _props.iconType,
          iconLabel = _props.iconLabel;


      return React.createElement(
        ConnectEventTracking,
        null,
        function (_ref) {
          var category = _ref.category,
              label = _ref.label,
              action = _ref.action,
              value = _ref.value;

          var handleClick = function handleClick(e) {
            // If analytics info has been specified, send an event
            if (category && action) {
              sendEvent({
                category: category,
                label: label,
                action: action,
                value: value
              });
            }

            if (onClick) {
              onClick(e);
            }
          };

          return React.createElement(
            'button',
            {
              type: submit ? 'submit' : 'button',
              'data-test-id': testId,
              disabled: disabled || loading,
              className: className,
              onClick: handleClick
            },
            iconType && React.createElement(Icon, { type: iconType, label: iconLabel || false }),
            children
          );
        }
      );
    }
  }]);

  return Button;
}(React.Component);

Button.propTypes = {
  onClick: PropTypes.func,
  submit: PropTypes.bool,
  spaced: PropTypes.bool,
  direction: PropTypes.oneOf(['column', 'row']),
  className: PropTypes.string.isRequired,
  group: PropTypes.oneOf(['first', 'inbetween', 'last']),
  type: PropTypes.oneOf(['default', 'primary', 'success', 'warning', 'danger']).isRequired,
  testId: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  inverted: PropTypes.bool,
  children: PropTypes.node,
  iconType: PropTypes.string,
  iconLabel: PropTypes.string
};

Button.defaultProps = {
  submit: false,
  loading: false,
  inverted: false,
  type: 'default'
};

Button.displayName = 'Button';

export default createComponent(styles, Button);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-button/es/Button.js
// module id = 1007
// module chunks = 1